import { useMatches } from 'react-router-dom';
import { routeOf, type Route } from '@/lib/route';

/** Where the address bar says we are, or null while it names nothing we serve. */
export function useRoute(): Route | null {
  return routeOf(useMatches());
}
